<template>
  <div class="summary-ia" :class="[{ open }, color]">
    <div class="summary-ia-button-wrapper">
      <button
        type="button"
        aria-expanded="false"
        class="summary-ia-button"
        :aria-controls="region"
        :id="id"
        @click="open = !open"
      >
        <span class="label">
          {{ title }} <i v-icon:[`ia-${color}`] class="ia"></i>
        </span>
        <span class="icon">
          <i v-icon:chevron-down></i>
        </span>
      </button>
    </div>
    <div
      role="region"
      :id="region"
      :aria-labelledby="id"
      class="summary-ia-region"
    >
      <div class="summary-ia-region-wrapper">
        <div class="summary-ia-region-content">
          <div class="summary-ia-region-info" v-html="safeHtml"></div>
          <!-- <div ref="typing" class="summary-ia-region-info"></div> -->
          <!-- <div class="summary-ia-region-likes">
            <span>Valora este resumen</span>
            <button><i v-icon:like></i></button>
            <button><i v-icon:dislike></i></button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import showdown from "showdown";

export default {
  name: "VSummaryAccordion",
  props: {
    content: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "geb",
    },
  },
  data() {
    return {
      id: `summary-ia-${this._uid}`,
      region: `summary-ia-region-${this._uid}`,
      open: false,
      typed: null,
      converter: new showdown.Converter({
        parseHtml: false,
        simpleLineBreaks: true,
        noHeaderId: true,
        ghCompatibleHeaderId: false,
      }),
    };
  },
  computed: {
    safeHtml() {
      const plainHtml = this.converter.makeHtml(this.content);
      return plainHtml
        .replace(/<\/p>\s*<p>/g, "\n\n")
        .replace(/<br\s*\/?>/g, "\n")
        .replace(/<\/?[^>]+(>|$)/g, "")
        .replace(/\n{3,}/g, "\n\n")
        .replace(/\n\n/g, "</p><p>")
        .replace(/\n/g, "<br>")
        .replace(/^(.+)$/, "<p>$1</p>")
        .trim();
    },
  },
  watch: {
    open(a) {
      if (a) {
        this.typed?.start();
      } else {
        this.typed?.stop();
        setTimeout(() => {
          this.typed?.reset();
        }, 400);
      }
    },
  },
  mounted() {
    // this.typed = new Typed(this.$refs["typing"], {
    //   strings: [this.content],
    //   typeSpeed: 1,
    //   showCursor: false,
    // });
    // this.typed.stop();
    // this.typed.reset();
  },
};
</script>

<style lang="scss" scoped></style>
